<template>
  <li
    @click="click"
    class="app-navbar-item"
    :class="{ active, 'text-muted': !active }"
  >
    <slot />
  </li>
</template>

<script>
export default {
  name: 'AppNavbarItem',

  props: {
    active: Boolean,
  },

  methods: {
    click(e) {
      app.horizontalScrollElement({
        element: this.$el,
      })

      this.$emit('click', this)
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';

.app-navbar-item {
  flex: 1;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
  padding: #{math.div($defaultPadding, 3)} #{math.div($defaultPadding, 2)};

  &.active {
    position: relative;
    color: $secondaryColor;
  }
}
</style>
